import type { Transaction } from '@shared/transactions-types';
import { RoundingType } from '@shared/transactions-types';
import {
    isRoundingDonationTransaction,
    isRoundingSavingTransaction,
} from '@shared/transactions-utils';

export const getSavingsRoundingTarget = (transactionText?: string | null): string => {
    return transactionText?.replace('Rundungssparen ', '') ?? '';
};

export const getDonationsRoundingTarget = (transactionText?: string | null): string => {
    return transactionText?.replace('Spenden-App - Rundung ', '') ?? '';
};

export const findSavingBaseTransaction = (
    transactions: Transaction[],
    savingReference: string,
): Transaction | undefined => {
    return transactions.find((transaction) => {
        const { reference } = transaction;
        return reference === savingReference && !isRoundingSavingTransaction(transaction);
    });
};

export const findDonationBaseTransaction = (
    transactions: Transaction[],
    donationReference: string,
): Transaction | undefined => {
    return transactions.find((transaction) => {
        const { reference } = transaction;
        return reference === donationReference && !isRoundingDonationTransaction(transaction);
    });
};

export const updateSavingBaseTransaction = (
    baseTransaction: Transaction,
    savingTransaction: Transaction,
): void => {
    const { id, amount, additionalTexts } = savingTransaction;

    baseTransaction.roundingAmount = amount;
    baseTransaction.roundingTransactionId = id;
    baseTransaction.roundingTarget = getSavingsRoundingTarget(additionalTexts?.text1);
    baseTransaction.roundingType = RoundingType.SAVING;
};

export const updateDonationBaseTransaction = (
    baseTransaction: Transaction,
    donationTransaction: Transaction,
): void => {
    const { id, amount, additionalTexts } = donationTransaction;

    baseTransaction.roundingAmount = amount;
    baseTransaction.roundingTransactionId = id;
    baseTransaction.roundingTarget = getDonationsRoundingTarget(additionalTexts?.text1);
    baseTransaction.roundingType = RoundingType.DONATION;
};

export const matchRoundingTransactions = (transactions: Transaction[]): Transaction[] =>
    transactions.map((transaction) => {
        const { additionalTexts, reference } = transaction;

        if (isRoundingSavingTransaction(transaction) && additionalTexts?.text2) {
            const baseTransaction = findSavingBaseTransaction(transactions, reference);

            if (baseTransaction) {
                updateSavingBaseTransaction(baseTransaction, transaction);

                transaction.foundMainTransactionId = baseTransaction.id;
            }
        }

        if (isRoundingDonationTransaction(transaction) && additionalTexts?.text2) {
            const donationBaseTransaction = findDonationBaseTransaction(transactions, reference);

            if (donationBaseTransaction) {
                updateDonationBaseTransaction(donationBaseTransaction, transaction);

                transaction.foundMainTransactionId = donationBaseTransaction.id;
            }
        }

        return transaction;
    });
